import React from 'react';
import { WeaLocaleProvider } from 'ecCom';
import { addContentPath } from '../../util/pathUtil';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';

export default class Content_searchengine extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        const { moreLocal, iconMore } = data;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@85esqj`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-search-input-wrapper" style={{ width: '300px', marginTop: '5px' }}>
                            <span className="ant-input-group ant-search-input" style={{ marginLeft: '5px', height: '32px' }}>
                                    <span className="ant-input-wrapper">
                                        <input placeholder={getLabel(388032, '请输入您要搜索的内容')} type="text" className="ant-input" value="" style={{ top: '2px', right: '3px' }} />
                                    </span>
                                    <div className="ant-input-group-wrap">
                                        <button type="button" className="ant-btn ant-btn-icon-only ant-search-btn">
                                            <i className="anticon anticon-search" />
                                        </button>
                                    </div>
                            </span>
                        </div>
                    </div>
                    <div className="footer" id={`footer_${eid}`} style={{ textAlign: 'right' }}>
                        {moreLocal == 'footer' ? <a href="javascript:;"><img src={addContentPath(iconMore)} alt="" /></a> : ''}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_searchengine.js